import React from "react";
import { Grid, Autocomplete, TextField, GridProps, TextFieldProps } from "@mui/material";

interface FormAutoCompleteFieldProps
  extends Omit<TextFieldProps, "name" | "value" | "onChange" | "onBlur" | "select" | "error"> {
  fieldName: string;
  label: React.ReactNode;
  value?: string | number;
  error?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
  options: string[];
  onChange: (value: string, fieldName: string) => void;
  onBlur?: (fieldName: string, value: string) => void;
  gridProps?: GridProps;
  getOptionLabel: (option: string) => string;
}

const FormAutoCompleteField: React.FC<FormAutoCompleteFieldProps> = ({
  fieldName,
  label,
  value = "",
  error,
  helperText,
  disabled = false,
  options,
  onChange,
  onBlur,
  variant = "outlined",
  gridProps = { md: 4, sm: 12, xs: 12 },
  getOptionLabel: getOptionLabelProp,
  ...rest
}) => {
  const getOptionLabel = getOptionLabelProp || ((option: string) => option || "");
  const { 
    autoComplete, 
    defaultValue, 
    onFocus,
    ...autocompleteProps 
  } = rest;

  // Convert value (string | number) to Option object
  const selectedOption = value !== undefined && value !== null && value !== ""
    ? options.find((opt: string) => opt === value) || null
    : null;

  return (
    <Grid item {...gridProps}>
      <Autocomplete
        fullWidth
        options={options}
        id={`${fieldName}-autocomplete`}
        disabled={disabled}
        value={selectedOption}
        onChange={(event, newValue) => {
          const newValueStr = newValue ? String(newValue) : '';
          onChange(newValueStr, fieldName);
        }}
        size="small"
        getOptionLabel={getOptionLabel}
        // onKeyPress={(e) => checkAlphabetRestrict(e, "fieldName")}
        {...autocompleteProps}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant={variant}
            error={Boolean(error)}
            helperText={helperText ?? error ?? undefined}
          />
        )}
      />
    </Grid>
  );
};

export default FormAutoCompleteField;
